export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13499.b9b716a3.jpg";